export var CoherenceNotificationType;
(function (CoherenceNotificationType) {
    CoherenceNotificationType[CoherenceNotificationType["NONE"] = 1] = "NONE";
    CoherenceNotificationType[CoherenceNotificationType["STANDARD"] = 2] = "STANDARD";
    CoherenceNotificationType[CoherenceNotificationType["PENDING"] = 3] = "PENDING";
    CoherenceNotificationType[CoherenceNotificationType["SUCCESS"] = 4] = "SUCCESS";
    CoherenceNotificationType[CoherenceNotificationType["WARNING"] = 5] = "WARNING";
    CoherenceNotificationType[CoherenceNotificationType["BLOCKED"] = 6] = "BLOCKED";
    CoherenceNotificationType[CoherenceNotificationType["ERROR"] = 7] = "ERROR";
})(CoherenceNotificationType || (CoherenceNotificationType = {}));
export var NotificationItemStatus;
(function (NotificationItemStatus) {
    NotificationItemStatus["READ"] = "read";
    NotificationItemStatus["UNREAD"] = "unread";
})(NotificationItemStatus || (NotificationItemStatus = {}));
export var NotificationItemDisplayStatus;
(function (NotificationItemDisplayStatus) {
    NotificationItemDisplayStatus["DISMISS"] = "dismiss";
    NotificationItemDisplayStatus["NEW"] = "new";
    NotificationItemDisplayStatus["OLD"] = "old";
})(NotificationItemDisplayStatus || (NotificationItemDisplayStatus = {}));
//# sourceMappingURL=CoherenceNotificationItem.types.js.map